import React, { useEffect } from 'react'
import { ReactComponent as Logo } from './broadband.svg'
import { Widget } from '../shared/stickee-widget/Widget'
import { WidgetHeader } from '../shared/stickee-widget/WidgetHeader'
import { WidgetFooter } from '../shared/stickee-widget/WidgetFooter'
import { useGetWhiteLabelColorQuery } from './white-labeling.api'
import { loadScriptOnce } from '../utils/scriptLoader'

export const BroadbandQuotes = props => {
  const queryParameters = new URLSearchParams(window.location.search)
  const whiteLabelClientId = queryParameters.get('utm_source')
  const getTypeFromPath = () => {
    const path = location.pathname
    if (path.startsWith('/mobile')) return 'mobile'
    if (path.startsWith('/broadband')) return 'broadband'
    return 'broadband' // default to broadband if no match
  }
  const { data: whiteLabelColor, isLoading } = useGetWhiteLabelColorQuery(
    {
      clientId: whiteLabelClientId,
      type: getTypeFromPath()
    },
    {
      skip: !whiteLabelClientId
    }
  )

  useEffect(() => {
    if (isLoading) {
      return
    }

    let observer = null

    const loadScript = async () => {
      try {
        await loadScriptOnce(
          'https://whitelabels.stickeebroadband.co.uk/js/loader.js',
          {
            async: true
          }
        )
      } catch (error) {
        console.error('Failed to load whitelabels script:', error)
      }
    }

    if (whiteLabelColor?.styleConfig) {
      // Set up MutationObserver to watch for the custom element
      observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          mutation.addedNodes.forEach(node => {
            if (
              node.nodeType === Node.ELEMENT_NODE &&
              node.tagName === 'WHITELABELS-BROADBAND-SITE'
            ) {
              // Element found, modify its config immediately
              if (node.hasAttribute('config')) {
                try {
                  const originalConfig = JSON.parse(node.getAttribute('config'))

                  // TestThemClient will be removed, this is added for YT team to see visually whitelabeling capabilities
                  const modifiedConfig =
                    whiteLabelClientId === 'TestThemeClient'
                      ? {
                          ...originalConfig,
                          theme: {
                            ...originalConfig.theme,
                            primary_color: '#FF0000',
                            primary_negative_color: '#00FF00',
                            primary_accent_color: '#0000FF',
                            primary_accent_negative_color: '#FFFF00',
                            secondary_color: '#FF00FF',
                            secondary_negative_color: '#00FFFF',
                            secondary_accent_color: '#FFA500',
                            secondary_accent_negative_color: '#800080',
                            black_color: '#FF1493',
                            grey_dark_color: '#00CED1',
                            grey_medium_dark_color: '#9ACD32',
                            grey_medium_light_color: '#FF6347',
                            grey_light_color: '#DDA0DD',
                            white_color: '#7FFF00',
                            success_color: '#32CD32',
                            info_color: '#1E90FF',
                            warning_color: '#FFD700',
                            danger_color: '#DC143C',
                            background_color: '#F0F8FF',
                            body_color: '#2F4F4F',
                            heading_color: '#8B4513'
                          }
                        }
                      : {
                          ...originalConfig,
                          theme: {
                            ...originalConfig.theme,
                            primary_color: whiteLabelColor.styleConfig,
                            primary_accent_color: whiteLabelColor.styleConfig,
                            secondary_negative_color: whiteLabelColor.styleConfig,
                            grey_light_color: '#e6e6e6'
                          },
                          style: {
                            borderRadius: '10px'
                          }
                        }

                  node.setAttribute('config', JSON.stringify(modifiedConfig))
                  console.log(
                    'Config modified successfully:',
                    modifiedConfig.theme
                  )
                } catch (e) {
                  console.error('Failed to modify config:', e)
                }
              }
            }
          })
        })
      })

      // Start observing
      observer.observe(document.body, {
        childList: true,
        subtree: true
      })
    }

    loadScript()

    return () => {
      if (observer) {
        observer.disconnect()
      }
    }
  }, [whiteLabelColor, isLoading])

  return (
    <>
      <WidgetHeader logo={Logo} />
      <Widget widgetId="youtility-436" />
      <WidgetFooter />
    </>
  )
}
